import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useFetch, Context } from 'store';

import { PageWrapper } from '_src/shared/styles';
import { Select as SelectLms, Input } from '_src/shared/form-helpers';
import services from '_src/services';
import { Refresh, AsyncTable } from '_src/components';
import { debounce } from '_src/utils';
import { camelToSnakeCase } from '../../utils/helpers';

import { PageTitle, Row } from './styles';

const resource = 'activityLogs';

export default () => {
  const { getData } = useContext(Context);
  const actionsList = getData('activityLogs')?.actions;
  const config = services[resource];
  const { get: getInstructors } = useFetch(config.instructors);
  const [allInstructors, setAllInstructors] = useState([{ id: 'all', label: 'All' }]);
  const [location, setLocation] = useState('all');
  const [instructor, setInstructor] = useState('all');
  const [actionDescription, setActionDescription] = useState('');
  const [studentName, setStudentName] = useState('');
  const [actionName, setActionName] = useState('all');

  const [filterParams, setFilterParams] = useState({});

  const debounceCallback = useCallback(
    debounce(
      params => {
        setFilterParams(params);
      },
      1000,
      false
    ),
    []
  );

  useEffect(() => {
    fetchInstructors();
  }, []);

  const fetchInstructors = () => {
    getInstructors().then(res => {
      res.unshift({ id: 'all', label: 'All' });
      setAllInstructors(res);
    });
  };

  const handleTableSort = (_, __, sort) => {
    if (!sort.columnKey) {
      return;
    }

    setFilterParams({
      ...filterParams,
      orderBy: camelToSnakeCase(sort.columnKey),
      order: sort.order === 'ascend' ? 'asc' : 'desc'
    });
  };

  return (
    <PageWrapper>
      <Refresh />
      <PageTitle>School / Instructor Audit</PageTitle>
      <Row>
        <SelectLms
          showSearch
          label="Schools"
          onChange={(loc, name) => {
            setLocation(loc);

            if (loc !== 'all') {
              setFilterParams({ ...filterParams, branch: name.replace('School', '').trim() });
            } else {
              const { branch, ...rest } = filterParams;
              setFilterParams(rest);
            }
          }}
          {...config.location}
          value={location}
        />
        <SelectLms
          showSearch
          allowClear
          label="Instructor"
          placeholder="Select an instructor"
          onChange={i => {
            setInstructor(i);

            if (i !== 'all') {
              const instructorName = allInstructors.find(({ id }) => id === i);

              setFilterParams({ ...filterParams, instructor: instructorName?.label });
            } else {
              const { instructor, ...rest } = filterParams;
              setFilterParams(rest);
            }
          }}
          options={allInstructors}
          value={instructor}
        />

        <Input
          label="Student"
          onChange={value => {
            const name = value.trim();
            const { student, ...rest } = filterParams;

            setStudentName(value);

            if (name.length) {
              debounceCallback({ ...filterParams, student: name });
            } else {
              debounceCallback({ ...rest });
            }
          }}
          value={studentName}
        />

        <SelectLms
          showSearch
          allowClear
          label="Action"
          placeholder="Select an action"
          onChange={i => {
            setActionName(i);

            if (i === undefined) {
              const { action, ...rest } = filterParams;
              setFilterParams(rest);
              return;
            }

            if (i !== 'all') {
              const actionValue = actionsList.find(({ id }) => id === i);

              setFilterParams({ ...filterParams, action: actionValue.label });
            } else {
              const { action, ...rest } = filterParams;
              setFilterParams(rest);
            }
          }}
          options={actionsList}
          value={actionName}
        />

        <Input
          label="Action Description"
          onChange={value => {
            const desc = value.trim();

            setActionDescription(value);

            if (actionDescription.length) {
              debounceCallback({ ...filterParams, actionDescription: desc });
            } else {
              const { actionDescription, ...rest } = filterParams;
              debounceCallback({ ...rest });
            }
          }}
          value={actionDescription}
        />
      </Row>

      <AsyncTable
        resource={resource}
        fileName={resource}
        pagination
        customPagination={true}
        config={{
          ...config
        }}
        params={filterParams}
        onChange={handleTableSort}
      />
    </PageWrapper>
  );
};
